import { FixedNumber } from '@ethersproject/bignumber'

export const Zero = FixedNumber.from(0)
export const FULL_100 = FixedNumber.from(100)
export const MAX_ACCOUNT_PER_TRANS = 200.0
export const ADDRESS_0 = '0x0000000000000000000000000000000000000000'
